import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Models from "@/pages/Models";
import ModelDetail from "@/pages/ModelDetail";
import Apply from "@/pages/Apply";
import Admin from "@/pages/Admin";
import Compcard from "@/pages/Compcard";
import Agent from "@/pages/Agent";
import ContractSign from "@/pages/ContractSign";
import ResetPassword from "@/pages/ResetPassword";
import Contact from "@/pages/Contact";
import Account from "@/pages/Account";
import AccountInvite from "@/pages/AccountInvite";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SmoothScroll />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/models" element={<Models />} />
          <Route path="/models/:slug" element={<ModelDetail />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/compcard" element={<Compcard />} />
          <Route path="/agent" element={<Agent />} />
          <Route path="/scout" element={<Agent />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/account" element={<Account />} />
          <Route path="/account/invite/:token" element={<AccountInvite />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/contract/:token" element={<ContractSign />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
